import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@hal/common';
import { Observable, Subject } from 'rxjs';
import { ScenarioSankeyStatesEnum } from '../enums/ScenarioSankeyStatesEnum';

@Injectable({
  providedIn: 'root',
})
export class ScenarioResultStore implements OnDestroy {
  private readonly _unsubscriber: Subject<void> = new Subject<void>();
  private readonly _store = new Store<{
    resultState: Map<string, ScenarioSankeyStatesEnum>;
  }>(
    {
      resultState: new Map(),
    },
    this._unsubscriber
  );
  public resultState$: Observable<Map<string, ScenarioSankeyStatesEnum>> = this._store.select('resultState');

  public get resultState(): Map<string, ScenarioSankeyStatesEnum> {
    return this._store.getState().resultState;
  }

  public get state(): any {
    return this._store.getState();
  }

  public getResultState(uuid: string) {
    return this.resultState.get(uuid);
  }

  public setResultState(uuid: string, value: ScenarioSankeyStatesEnum) {
    const resultStateClone = structuredClone(this.resultState);
    resultStateClone.set(uuid, value);
    this.resultState = resultStateClone;
  }

  public ngOnDestroy(): void {
    this._unsubscriber.next();
    this._unsubscriber.complete();
  }

  public set resultState(resultState: Map<string, ScenarioSankeyStatesEnum>) {
    this._store.setState({ resultState });
  }
}
